export default __webpack_public_path__ + "ef5a7fc.png";